'use strict'

export default class Share
{
  constructor()
  {
    this.$elem = $('.Share')

    if( this.$elem.length > 0 ){
      let self = this

      $(document).ready(function() {
        $('.button-share').click(function(e) {
          e.preventDefault()
          window.open($(this).attr('href'), 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0')
          return false
        })

        let $layout = $('.Page, .Archive, .Single')
        $layout.addClass('with-share')

        let $shareDesktop = $('.Share:not(.mobile)')
        self.selfOffsetTopDesktop = $shareDesktop.offset().top

        let $header = $('#header')

        $( window ).scroll( ()=> {
          if( window.innerWidth >= 768 ){
            let currentScroll = $(window).scrollTop() + $header.outerHeight()
            if( currentScroll >= self.selfOffsetTopDesktop - 50 ){
              if( !$shareDesktop.hasClass('sticky') ){
                $shareDesktop.addClass('sticky')
              }

              let valuePadding = $layout.css('padding-bottom')
              valuePadding = valuePadding.replace('px', '')
              valuePadding = Number(valuePadding)

              let valueHeightTotal = $(document).outerHeight() - $('.Footer').outerHeight()
              valueHeightTotal -= valuePadding
              valueHeightTotal -= $shareDesktop.outerHeight()
              valueHeightTotal -= 50

              if( currentScroll >= valueHeightTotal ){
                if( !$shareDesktop.hasClass('--bottom') ){
                  $shareDesktop.addClass('--bottom')
                }
              } else{
                if( $shareDesktop.hasClass('--bottom') ){
                  $shareDesktop.removeClass('--bottom')
                }
              }
            } else{
              if( $shareDesktop.hasClass('sticky') ){
                $shareDesktop.removeClass('sticky')
              }
            }
          }
        })
      })
    }
  }
}

